import { defineMessages } from 'react-intl';
export const messages = defineMessages({
    myLabsTitle: {
        id: 'Labs',
        defaultMessage: 'Labs',
        description: 'Label to indicate this is the Labs page',
    },
});
export default messages;
